import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormGroup } from "react-bootstrap-3";
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";
import FroalaEditorComponent from "react-froala-wysiwyg";
// Import all Froala Editor plugins;
import "froala-editor/js/plugins.pkgd.min.js";

// Import a single Froala Editor plugin.
import "froala-editor/js/plugins/align.min.js";

// Import a language file.
import "froala-editor/js/languages/es.js";

import "./richHTMLEditor.css";

import styled from "styled-components";

const FroalaWrapper = styled.div`
  ${props => (props.disabled ? `pointer-events: none; opacity: 0.5;` : ``)}
`;

class RichHTMLEditorGroup extends Component {
  onModelChange = model => {
    this.props.onChange({
      field: this.props.field.fieldName,
      value: model,
    });
  };

  render() {
    const { value, disabled } = this.props;
    const { dontShowInsertVideo, fullPage = false } = this.props.field;
    const htmlEditorConfig = {
      key: "vYA6mC4C4C4G4B2B11dxE-11vusB2hiue1lknoioB9idaqD1G1F4A3B1C8E6D2C4A4==",
      attribution: false,
      fullPage,
      htmlRemoveTags: ["script", "base"],
      charCounterCount: false,
      toolbarButtons: {
        moreText: {
          buttons: [
            "bold",
            "italic",
            "underline",
            "strikeThrough",
            "subscript",
            "superscript",
            "fontFamily",
            "fontSize",
            "textColor",
            "backgroundColor",
            "inlineClass",
            "inlineStyle",
            "clearFormatting",
          ],
        },
        moreParagraph: {
          buttons: [
            "alignLeft",
            "alignCenter",
            "formatOLSimple",
            "alignRight",
            "alignJustify",
            "formatOL",
            "formatUL",
            "paragraphFormat",
            "paragraphStyle",
            "lineHeight",
            "outdent",
            "indent",
            "quote",
          ],
        },
        moreRich: {
          buttons: [
            "insertLink",
            "insertImage",
            dontShowInsertVideo ? "" : "insertVideo",
            "insertTable",
            "emoticons",
            "fontAwesome",
            "specialCharacters",
            "embedly",
            "insertHR",
          ],
        },
        moreMisc: {
          buttons: [
            "undo",
            "redo",
            "fullscreen",
            "print",
            "getPDF",
            "spellChecker",
            "selectAll",
            "html",
            "help",
          ],
          align: "right",
          buttonsVisible: 2,
        },
      },
      language: window.wbkLocale || "es",
      pastePlain: true,
    };
    return (
      <FroalaWrapper disabled={disabled}>
        <FormGroup>
          <FroalaEditorComponent
            model={value}
            config={{ ...htmlEditorConfig }}
            onModelChange={this.onModelChange}
          />
        </FormGroup>
      </FroalaWrapper>
    );
  }
}

RichHTMLEditorGroup.propTypes = {
  field: PropTypes.object,
  formErrors: PropTypes.object,
  formValues: PropTypes.object,
  hasErrors: PropTypes.bool,
  onChange: PropTypes.func,
};

export default RichHTMLEditorGroup;
